import { ReactNode } from 'react';

const calculateHideTimeout = (children: ReactNode): number | undefined => {
    if (typeof children === 'string') {
        return 500 + children.length * 100;
    }

    if (children) {
        return 1500;
    }

    return undefined;
};

export default calculateHideTimeout;
